import React from "react";
import LoggedOutAlertService, { LoggedOutAlertObserver } from "../services/LoggedOutAlertService";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import { RawLinkButton } from "./LinkButton";
import { ApplicationPaths, QueryParameterNames } from "./api-authorization/ApiAuthorizationConstants";
import { withRouter, RouteComponentProps } from "react-router";

const LoggedOutAlert: React.FC<RouteComponentProps> = (props: RouteComponentProps) => {
  const [authFailed, setAuthFailed] = React.useState<boolean>(false);
  const { history } = props;

  const onLoggedOutAlertUpdated: LoggedOutAlertObserver = () => {
    setAuthFailed(true);
  };

  React.useEffect(() => {
    LoggedOutAlertService.attach(onLoggedOutAlertUpdated);
    return () => LoggedOutAlertService.detach(onLoggedOutAlertUpdated);
  });

  const handleClose = async () => {
    const redirectUrl = `${ApplicationPaths.LogOut}?${QueryParameterNames.ReturnUrl}=${encodeURI(window.location.href)}`;

    setAuthFailed(false);
    history.push(redirectUrl, { local: true });
  };

  return (
    <Dialog open={authFailed} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{"Session Expired"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">Your session has expired. Please login again to continue.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <RawLinkButton onClick={handleClose} color="primary">
          Okay
        </RawLinkButton>
      </DialogActions>
    </Dialog>
  );
};

export default withRouter(LoggedOutAlert);
